export default {"src":"/_next/static/media/edoge.5608b664.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};